function normalizeFeatureKey(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
}

export function parseFeatureAccessFromProfile(profileResponse) {
  if (!profileResponse || typeof profileResponse !== "object") {
    return null;
  }

  const directObjectSources = [
    profileResponse.feature_access,
    profileResponse.featureAccess,
    profileResponse.features,
    profileResponse?.limits?.features,
  ];

  for (const source of directObjectSources) {
    if (source && typeof source === "object" && !Array.isArray(source)) {
      const mapped = Object.entries(source).reduce((acc, [rawKey, rawValue]) => {
        const key = normalizeFeatureKey(rawKey);
        if (!key) return acc;
        acc[key] = Boolean(rawValue);
        return acc;
      }, {});

      if (Object.keys(mapped).length > 0) {
        return mapped;
      }
    }
  }

  const arraySources = [
    profileResponse.allowed_features,
    profileResponse.allowedFeatures,
    profileResponse.plan_features,
    profileResponse.planFeatures,
  ];

  for (const source of arraySources) {
    if (Array.isArray(source)) {
      const mapped = source.reduce((acc, rawKey) => {
        const key = normalizeFeatureKey(rawKey);
        if (!key) return acc;
        acc[key] = true;
        return acc;
      }, {});

      if (Object.keys(mapped).length > 0) {
        return mapped;
      }
    }
  }

  return null;
}

export function isFeatureAllowed(featureAccess, keys, fallback = true) {
  if (!featureAccess || typeof featureAccess !== "object") {
    return fallback;
  }

  const candidates = Array.isArray(keys) ? keys : [keys];
  if (candidates.length === 0) {
    return fallback;
  }

  return candidates.some((candidate) => {
    const key = normalizeFeatureKey(candidate);
    if (!key) return false;
    return featureAccess[key] === true;
  });
}

